import moment from "moment";
import { useSelector } from "react-redux";
import { DateType, TimeType } from "../models/dateFormat";
import {
  formatBATSDateTime,
  formatCDMDateTime,
  getBrowserDateFormat,
  getDateFormatByLanguageCode,
} from "../utils/dateFormat.util";

import {
  selectAccountDateFormat
} from "../redux-toolkit/accountReducer";

import {
  selectCountryCode,
  selectLanguage
} from "../redux-toolkit/authReducer";
import { Constants } from "../helpers/Constants";

export const useAccountDateFormat = () => {
  const formatDate = (date: string) => {
    const dateMoment = moment(date);
    return dateMoment.format("DD/MM/YYYY");
  };
  return formatDate;
};

export const useDateFormat = () => {
  const dateFormat = useSelector(selectAccountDateFormat);
  const countryCode = useSelector(selectCountryCode);
  const langCode = useSelector(selectLanguage);
  const separtor = ".";
  const germanyDateFormat = DateType.DMY;

  const formatDate = (
    date: string,
    dateSeparator?: string,
    timeType?: TimeType
  ) => {

    // if(Constants.GERMANY_DATE_FORMAT_COUNTRIES.includes(countryCode)){
    //   return formatCDMDateTime({
    //     input: date,
    //     dateSeparator: separtor,
    //     dateType: !!dateFormat
    //       ? (dateFormat as DateType)
    //       :  germanyDateFormat,
    //     timeType,
    //   });
    // } else {
    //   return formatCDMDateTime({
    //     input: date,
    //     dateSeparator,
    //     dateType: !!dateFormat
    //       ? (dateFormat as DateType)
    //       :  getBrowserDateFormat(),
    //     timeType,
    //   });
    // }

    return formatBATSDateTime({
      input: date,
      dateSeparator,
      dateType: !!dateFormat
        ? (dateFormat)
        :  getDateFormatByLanguageCode(langCode),
      timeType,
    });
  };

  return formatDate;
};



